import React, {  useMemo } from "react";
import AuthErrorPage from "./auth-error-page";
import { useSidebar } from "@/components/ui/sidebar";
// import Cookies from "universal-cookie";
import { Navigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { RootState } from "@/store";
// import { User } from "@/features/auth/types";

interface ProtectedRouteProps {
  // isAuthenticated: boolean;
  children: JSX.Element;
  moduleName?: string;
  settingModuleName?: string;
  forceOverlay?: boolean
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  // isAuthenticated,
  children,
  moduleName,
  settingModuleName,
  forceOverlay = false
}) => {
  const { open } = useSidebar();
  // const cookies = new Cookies();

  // const isAuth = useMemo(() => {
  //   const user = JSON.parse(localStorage.getItem("user") + "");
  // }, []);

  

  // useEffect(() => {
  //   if (isAuth) {
  //     cookies.set("isAuthenticated", "true", {
  //       expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
  //     });
  //   } else {
  //     cookies.set("isAuthenticated", "false");
  //   }
  // }, [isAuth]);


  const user = useMemo(() => {
    return JSON.parse(localStorage.getItem("user") || "null");
  }, []);

const accessRights = useMemo(() => user?.accessRights || {}, [user]);
console.log("accessRights", accessRights);

const hasModuleAccess = useMemo(() => {
  console.log("moduleName", moduleName);
  if (!moduleName) return true;
  if(moduleName==="organization-users")return true;

  return accessRights[moduleName as keyof typeof accessRights] !== undefined;
}, [accessRights, moduleName]);


  const isAuth = (!!user) && (user.accessRights.isCRMSubscribedUser === true);

  // useEffect(() => {
  //   cookies.set("isAuthenticated", isAuth ? "true" : "false", {
  //     expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
  //   });
  // }, [isAuth]);

  //  const userDetails = useSelector(
  //   (state: RootState) => state.rootReducer.userReducer.user
  // );
  //  const skipQuestions = useSelector(
  //   (state: RootState) => state.rootReducer.userReducer.skipQuestions
  // );

  // if(userDetails?.questionnaireFilled=== false  && skipQuestions === false) {
  //     //if the user is not authenticated(not logged In), redirect to the home page
  //     return <Navigate to="/chat/newOnboarding" replace />;
  //   }


  if(!isAuth && !(user.accessRights?.explore == "temp_user") && (user.isCRMSubscribedUser === true)) {
    //if the user is not authenticated(not logged In), redirect to the home page
    return <Navigate to="/" replace />;
  }

  const isOrgUserSpecialCase =
  moduleName === "organization-users" &&
  accessRights?.isOrgAdmin === true &&
  accessRights?.showOrgUsersView === false; 

const tempUserAccess = (hasModuleAccess && (settingModuleName=== "organization-users"|| settingModuleName === "integrations" || settingModuleName === "email-template" || settingModuleName === "company-profile") && accessRights?.isCRMSubscribedUser ===false)?true:false;

  if ( !hasModuleAccess || forceOverlay || isOrgUserSpecialCase ||tempUserAccess) {
    // If the user does not have access to the particular route/module, show the AuthErrorPage overlay on top of the children
    return (
      <div className="relative">
        {/* Render the auth error overlay */}
        <div
          className={`fixed top-13 z-50 bg-[#000000]/60 ${open ? "w-[90vw]" : "w-[98vw]"}`}
        >
          <AuthErrorPage forceOverlay={forceOverlay}/>
        </div>
        {/* Render the protected content in the background */}
        <div className="pointer-events-none">{children}</div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
